import {Component, inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ImageCroppedEvent, LoadedImage} from "ngx-image-cropper";
import {DomSanitizer, SafeUrl} from "@angular/platform-browser";

@Component({
  selector: 'app-image-cropper-modal',
  templateUrl: './image-cropper-modal.component.html',
  styleUrl: './image-cropper-modal.component.scss'
})
export class ImageCropperModalComponent implements OnInit {

  protected data: { event: Event; aspectRatioX: number; aspectRatioY: number } = inject(MAT_DIALOG_DATA);
  private dialogRef: MatDialogRef<ImageCropperModalComponent> = inject(MatDialogRef<ImageCropperModalComponent>);
  private sanitizer: DomSanitizer = inject(DomSanitizer)

  title: string = 'Image Cropper';


  imageChangedEvent: Event | null = null;
  croppedImage: SafeUrl  = '';
  croppedImageEvent: ImageCroppedEvent

  ngOnInit() {
    this.imageChangedEvent = this.data?.event;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(event.objectUrl);
    this.croppedImageEvent = event
  }
  imageLoaded(image: LoadedImage) {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }


  closeModal() {
    this.dialogRef.close({
      isSelected: false
    })
  }

  cropImage() {
    this.dialogRef.close({
      isSelected: true,
      croppedImage: this.croppedImage,
      croppedImageEvent: this.croppedImageEvent
    })
  }
}
